import React from "react";
import { SEO } from "@bluefin/components";
import { Grid, Segment, Embed } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class ReviewsPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.kjandkompany.com/reviews/"}
        />
        <Grid
          className={"custom-page-reviews custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"pkbbldpgepfhefbg"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"dgpcomflhgmgeall"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__4adc46fd-2082-4d0a-b091-cac2231f9a6a"}
                >
                  <Embed
                    url={"https://na0.meevo.com/NhPe"}
                    autoplay={true}
                    defaultActive={true}
                    className={""}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 38493 }) {
      title
      seoTitle
      description
    }
  }
`;
